module.exports = __webpack_public_path__ + "img/972cb57.png";